import * as THREE from "three";
import { Vector2 } from "three";
import { pillarRoughness, pillarRoughness2 } from "./assets/materials";
import { colorMap, MatColor } from "../entities/OfferItem";
export class MaterialPicker {
    constructor(scene) {
        this.scene = scene;
    }
    getMaterial(repeat = new Vector2(), normal = undefined, isFrame = true, metalness = 0.5) {
        let map = new THREE.Texture();
        const pillarTextureRepeat = repeat;
        map.repeat = pillarTextureRepeat;
        const color = isFrame === true ? this.scene.formData.frameColor : this.scene.formData.panelColor;
        let matte = false;
        if (isFrame === true && color === MatColor.PPMAT611 || isFrame === true && color === MatColor.PPMAT613 || isFrame === true && color === MatColor.PPMAT617)
            matte = true;
        if (normal === undefined) {
            return new THREE.MeshStandardMaterial({
                color: parseInt(colorMap[color]),
                metalness: metalness,
                roughnessMap: isFrame === true && matte === false ? pillarRoughness : pillarRoughness2,
                roughness: isFrame === true ? 1 : 0.4,
                polygonOffset: true,
                flatShading: true,
                //polygonOffsetFactor: -1
            });
        }
        else {
            normal.repeat = pillarTextureRepeat;
            return new THREE.MeshStandardMaterial({
                color: parseInt(colorMap[this.scene.formData.frameColor]),
                normalMap: normal,
                metalness: metalness,
                roughnessMap: pillarRoughness,
                polygonOffset: true,
                polygonOffsetFactor: -1,
                flatShading: true,
            });
        }
    }
}
